module.exports = "/images/embed.svg?b8b7ed110ef94dfd22cea4c1a0d9fe75";